export default {
  pageTitle: 'Piping Repair Service',
  metaDescription: 'TEF provides piping repair and maintenance services to restore integrity and prevent downtime for critical process piping systems.',
  sidebar: {
    heading: 'Maintenance And Reconditioning list',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Piping',
  heading: 'Comprehensive Piping Fabrication and Welding Services',
  paragraph1: 'We specialize in the fabrication, welding, and installation of piping systems, tailored to meet your specific requirements. Our services offer flexibility, with fabrication performed either in our workshop or directly at your site, depending on your project needs.',
  paragraph2: 'From precision welding to seamless installation, our experienced team ensures the highest quality standards at every stage of the process. By offering on-site services, we minimize downtime and enhance efficiency, delivering reliable solutions that integrate seamlessly into your operations.',
  steps: {
    step1: 'Shopfloor Welding',
    step2: 'Piping Installation',
    step3: 'Support Installation',
    step4: 'Piping Installation',
    step5: 'Support Installation',
    step6: 'Support Installation',
    step7: 'Support Installation',
  },
};
